import { useParams, Link } from 'react-router-dom';
import { useEffect } from 'react';
import { products } from '@/mocks/products';
import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';
import ProductDetailHero from './components/ProductDetailHero';
import ProductDetailInfo from './components/ProductDetailInfo';
import ProductDetailRelated from './components/ProductDetailRelated';
import ProductJsonLd from '@/components/seo/ProductJsonLd';
import ProductSeo from '@/components/seo/ProductSeo';

const ProductPage = () => {
  const { id } = useParams<{ id: string }>();
  const product = products.find((p) => p.id === Number(id));

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [id]);

  if (!product) {
    return (
      <div className="min-h-screen font-sans">
        <Navbar />
        <div className="flex flex-col items-center justify-center min-h-screen gap-6 text-center px-6">
          <i className="ri-error-warning-line text-5xl text-gray-300" />
          <h2 className="text-2xl font-bold text-[#1a2b4a]">제품을 찾을 수 없습니다</h2>
          <p className="text-gray-400 text-sm">요청하신 제품 정보가 존재하지 않습니다.</p>
          <Link
            to="/#products"
            className="inline-flex items-center gap-2 bg-[#1a2b4a] text-white text-sm font-semibold px-6 py-3 rounded-md hover:bg-[#243d6a] transition-colors duration-200 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-arrow-left-line" />
            제품 목록으로
          </Link>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen font-sans">
      <ProductSeo product={product} />
      <ProductJsonLd product={product} />
      <Navbar />
      <ProductDetailHero product={product} />
      <ProductDetailInfo product={product} />
      <ProductDetailRelated currentId={product.id} />
      <Footer />
    </div>
  );
};

export default ProductPage;
